import React from 'react';
import cn from 'classnames';
import type { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';
import Image, { IImage } from 'tbk-components/src/components/Image';
import { accentColors, colorMap } from '../../utils';

export interface ICtaBarProps extends IBaseElementProps {
	heading?: string;
	text?: string;
	image?: IImage;
	button?: ILink;
	backgroundColor?: accentColors;
}

/**
 * Large Call To Action Banner
 * @icon interactive
 * @block
 */

const CtaBar: React.FC<ICtaBarProps> = ({
	heading,
	text,
	backgroundColor = 'yellow',
	button,
	image,
}) => (
	<div className={cn('cta-bar', `cta-bar--bg-${colorMap[backgroundColor]}`)}>
		{image && (
			<div className="cta-bar__image">
				<Image {...image} />
			</div>
		)}
		<div className="cta-bar__content-wrapper">
			<div className="cta-bar__content">
				{heading && <h2>{heading}</h2>}
				{text && <p>{text}</p>}
				{button && <Button {...button} type="secondary" size="lg" />}
			</div>
		</div>
	</div>
);

export default CtaBar;
